module.exports = __webpack_public_path__ + "60775de8ede09ea0ff60b1a6b12a9992.png";